module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4a-c6993702f3e161edf010c503f35d2da2.png";